import { ResponseActionTypes } from './types';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import Services from '../../services';
import {
  fetchResponseAttachmentsFailure,
  fetchResponseAttachmentsSuccess,
  getResponseAttachmentDownloadLinkSuccess,
  getResponseAttachmentDownloadLinkFailure,
  getResponseAttachmentsDownloadAllSuccess,
  getResponseAttachmentsDownloadAllFailure
} from './actions';

export function* doFetchResponseAttachments(request: any) {
  try {
    const { token, userId } = request.payload;
    const resopnse = yield call(
      Services.response.fetchResponseAttachments,
      token,
      userId
    );
    if (!resopnse.error) {
      yield put(fetchResponseAttachmentsSuccess(resopnse));
    } else {
      const errMsg = resopnse.error?.message;
      yield put(fetchResponseAttachmentsFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error?.message ? error.message : error;
    yield put(fetchResponseAttachmentsFailure(errorMsg));
  }
}

export function* doGetResponseAttachmentDownloadLink(request: any) {
  try {
    const { token, fileId, userId } = request.payload;
    const resopnse = yield call(
      Services.response.getResponseAttachmentDownloadLink,
      token,
      fileId,
      userId
    );
    if (!resopnse.error) {
      yield put(getResponseAttachmentDownloadLinkSuccess(resopnse));
    } else {
      const errMsg = resopnse.error?.message;
      yield put(getResponseAttachmentDownloadLinkFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error?.message ? error.message : error;
    yield put(getResponseAttachmentDownloadLinkFailure(errorMsg));
  }
}

export function* doGetResponseAttachmentsDownloadAll(request: any) {
  try {
    const { token, userId } = request.payload;
    const resopnse = yield call(
      Services.response.getResponseAttachmentsDownloadAll,
      token,
      userId
    );
    if (!resopnse.error) {
      yield put(getResponseAttachmentsDownloadAllSuccess(resopnse));
    } else {
      const errMsg = resopnse.error?.message;
      yield put(getResponseAttachmentsDownloadAllFailure(errMsg));
    }
  } catch (error) {
    const errorMsg = error?.message ? error.message : error;
    yield put(getResponseAttachmentsDownloadAllFailure(errorMsg));
  }
}

export function* onFetchResponseAttachments() {
  yield takeLatest(
    ResponseActionTypes.FETCH_RESPONSE_ATTACHMENTS_START,
    doFetchResponseAttachments
  );
}

export function* onGetResponseAttachmentDownloadLink() {
  yield takeLatest(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_START,
    doGetResponseAttachmentDownloadLink
  );
}

export function* onGetResponseAttachmentsDownloadAll() {
  yield takeLatest(
    ResponseActionTypes.GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_START,
    doGetResponseAttachmentsDownloadAll
  );
}

export function* responseSagas() {
  yield all([
    call(onFetchResponseAttachments),
    call(onGetResponseAttachmentDownloadLink),
    call(onGetResponseAttachmentsDownloadAll)
  ]);
}

export default responseSagas;
